import { MEDIA_QUERY, px2rem, useScrollStyle } from "@moim/common";
import styled from "styled-components";

export const Wrapper = styled.div`
  /* NOTE: 45 + 8 ==> appbarHeight + margin/padding */
  height: calc(100% - ${px2rem(53)});
  @media ${MEDIA_QUERY.EXCEPT_MOBILE} {
    min-width: ${px2rem(455)};
    padding: 0 ${px2rem(24)} ${px2rem(20)};
  }
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const ScrollSection = styled.div`
  flex: 1;
  min-width: 0;
  ${useScrollStyle};
`;
